import posthog, { type Properties } from 'posthog-js'

interface SignedInProps extends Properties {
  email: string
}

interface SignUpProps extends Properties {
  email: string
}

interface TrialCaseNamedProps extends Properties {
  account_id: number
  email?: string
}

export const eventTracker = {
  signedIn: (data: SignedInProps) => {
    posthog.identify(data.email, data)
    posthog.capture('signedIn', data)
  },
  // Sent at once: the page leaves for checkout right after, which can drop a queued event.
  signUp: (data: SignUpProps) =>
    posthog.capture('signUp', data, { send_instantly: true }),
  // The Meta ads optimize on this event. Sent at once because the page moves to the case right after.
  trialCaseNamed: (data: TrialCaseNamedProps) =>
    posthog.capture('trial_case_named', data, { send_instantly: true }),
}
